import debounce from 'lodash/debounce';
import type { Plugin } from '@nuxt/types';

const getScrollPercent = () => {
  const h = document.documentElement;
  const b = document.body;
  const st = 'scrollTop';
  const sh = 'scrollHeight';
  return ((h[st] || b[st]) / ((h[sh] || b[sh]) - h.clientHeight)) * 100;
};

export default (ctx => {
  if (process.env.isDev || !process.client) return;

  const isWelcome = window.location.pathname === '/';

  window.onNuxtReady(() => {
    if (!isWelcome) return;

    window.addEventListener(
      'scroll',
      debounce(() => {
        let scrollZone;
        const scrollPercent = getScrollPercent();
        if (scrollPercent < 15) {
          return;
        }

        if (scrollPercent >= 75) {
          scrollZone = '75-100';
        } else if (scrollPercent >= 55) {
          scrollZone = '55-75';
        } else if (scrollPercent >= 35) {
          scrollZone = '35-55';
        } else if (scrollPercent >= 15) {
          scrollZone = '15-35';
        }
        ctx.app.$analytics.logEvent('Scroll To', {
          pathname: window.location.pathname,
          scrollZone,
        });
      }, 300),
    );
  });
}) as Plugin;
